<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <div class="absolute top-0 right-0 pt-4 pr-4">
                <button (click)="close()" mat-icon-button>
                    <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </ng-container>
        <ng-container>
            <div class="flex w-full border-b pb-3 gap-4 items-center">
                @if (data.message.status == processingStatus.SUCCESSFUL) {
                <mat-icon class="relative icon-size-8 text-green-600" fontIcon="check_circle"></mat-icon>
                } @if (data.message.status == processingStatus.FAILED) {
                <mat-icon class="relative icon-size-8 text-red-800" fontIcon="cancel"></mat-icon>
                } @if (data.message.status == processingStatus.PROCESSING) {
                <mat-icon class="relative animate-spin icon-size-8 text-blue-600" fontIcon="autorenew"></mat-icon>
                } @if (data.message.status == processingStatus.QUEUED) {
                <mat-icon class="relative icon-size-8 text-gray-500" fontIcon="schedule"></mat-icon>
                }
                <div class="text-2xl sm:text-4xl font-bold truncate basic-fuse-gray-color">
                    {{ 'label_tasks' | translate }} #{{data.message.id}}
                </div>
            </div>
            <div class="float-left w-full mt-2 mb-2">
                <div class="flex flex-row flex-wrap mt-2 mb-4 gap-x-6">
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_status' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ statusLabel | translate }}</div>
                    </div>
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_type' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ 'label_message_' + data.message.type | translate }}</div>
                    </div>
                    @if (data.message.retries > 0) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_retries' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ data.message.retries }}</div>
                    </div>
                    }
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_created_at' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ data.message.createdAt | date:'dd.MM.yyyy HH:mm:ss' }}</div>
                    </div>
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_last_activity_at' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ data.message.timeStamp | date:'dd.MM.yyyy HH:mm:ss' }}</div>
                    </div>
                    @if (data.message.errorSentryId) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_failed' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{ data.message.errorSentryId }}</div>
                    </div>
                    }
                </div>
            </div>
            <div>
                <div class="text-sm font-medium leading-none text-secondary">{{ 'label_data' | translate }}</div>
                <div class="mt-2 bg-gray-100 rounded p-2">
                    <code>
                        <pre [textContent]="body | json"></pre>
                    </code>
                </div>
            </div>
        </ng-container>
    </div>
</span>
